<nz-card nzTitle="Review Order">

    <p>Confirm the selected information in order to submit order.</p>


    <nz-card style="margin: 5px;" nzTitle="Customer Info">
      <nz-list nzBordered>

          <nz-list-item>
            <span nz-typography>Full Name</span>
            {{ fullData?.customerInfo?.firstName }} {{ fullData?.customerInfo?.lastName }}
          </nz-list-item>

          <nz-list-item>
            <span nz-typography>Phone</span>
            {{ fullData?.customerInfo?.phone }}
          </nz-list-item>
      
      </nz-list>

    </nz-card>


    <nz-card style="margin: 5px;" nzTitle="Service Address">
      <nz-list nzBordered>

        <nz-list-item>
          <span nz-typography>Address</span>
          {{ fullData?.customerInfo?.address }}
        </nz-list-item>

        <nz-list-item>
          <span nz-typography>City</span>
          {{ fullData?.customerInfo?.city }}
        </nz-list-item>

        <nz-list-item>
          <span nz-typography>State</span>
          {{ fullData?.customerInfo?.state }}
        </nz-list-item>

        <nz-list-item>
          <span nz-typography>Zip</span>
          {{ fullData?.customerInfo?.zip }}
        </nz-list-item>
    
    </nz-list>
    </nz-card>


    <nz-card style="margin: 5px;" nzTitle="Processing Fee Details" *ngIf="fullData?.processingFee?.pfeeInfo?.processingFeeDate">
      <nz-list nzBordered>

        <nz-list-item>
          <span nz-typography>Fee Amount</span>
          {{ fullData?.processingFee?.pfeeInfo?.processingFee }}
        </nz-list-item>

        <nz-list-item>
          <span nz-typography>Fee Charge Date</span>
          {{ fullData?.processingFee?.pfeeInfo?.processingFeeDate | date: 'mediumDate' }}
        </nz-list-item>
    
      </nz-list>
    </nz-card>


    <nz-card style="margin: 5px;" nzTitle="Payment & Preferences">
      <nz-list nzBordered>

        <nz-list-item *ngIf="fullData?.processingFee?.pfeeInfo?.promoCode">
          <span nz-typography>Promo code</span>
          {{ fullData?.processingFee?.pfeeInfo?.promoCode }}
        </nz-list-item>

        <nz-list-item>
          <span nz-typography>Autopay</span>
          {{ fullData?.processingFee?.pfeeInfo?.autopay ? 'Yes' : 'No' }}
        </nz-list-item>

        <nz-list-item>
          <span nz-typography>Paperless Billing</span>
          {{ fullData?.processingFee?.pfeeInfo?.paperless ? 'Yes' : 'No' }}
        </nz-list-item>

        <nz-list-item>
          <span nz-typography>Security Pin</span>
          {{ fullData?.processingFee?.pfeeInfo?.pin }}
        </nz-list-item>

        <nz-list-item>
          <span nz-typography>Pin Hint</span>
          {{ fullData?.processingFee?.pfeeInfo?.pinHint }}
        </nz-list-item>
    
      </nz-list>

    </nz-card>


    <nz-card nzTitle="Dish Order Details">
      <div *ngFor="let p of pricing">
        <nz-card *ngIf="p.Products?.length > 0" [nzTitle]="p.CategoryName">

          <nz-list nzBordered [nzFooter]="p.CategoryTotal ? 'Total: ' + p.CategoryTotal : ''">

            <nz-list-item *ngFor="let info of p.Products">
              <span nz-typography>{{ info.ProductName }}</span>
              {{ info.Price | currency }}
            </nz-list-item>
        
          </nz-list>
        </nz-card>
      </div>
    </nz-card>


    <nz-card nzTitle="Install Details">
      <nz-list nzBordered>

        <nz-list-item>
          <span nz-typography>Date</span>
          {{ formatDateForPipe(fullData?.install?.date) | date: 'mediumDate' }}
        </nz-list-item>

        <nz-list-item>
          <span nz-typography>Time Frame</span>
          {{ formatTime(fullData?.install?.windowStartTime) }} - {{ formatTime(fullData?.install?.windowEndTime) }}
        </nz-list-item>
    
      </nz-list>

    </nz-card>
  
  
    <div style="margin-top: 1.5rem;">
      <button nz-button nzType="primary" nzBlock (click)="reviewAccepted()" [nzLoading]="confirmButton">
        Next Step
      </button>
    </div>
  
  </nz-card>
  